<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Codici Rifiuto',
      link: '/codici-rifiuto'
    }, {
      label: form.uuid ? 'Modifica Codice Rifiuto' : 'Aggiungi nuova Codice Rifiuto'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.code"
      :error-fields="errorFields"
      name="code"
      :submitted="submitted"
    >
      Codice
    </InputText>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import InputText from "@/components/form/InputText.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  code: ""
});

if (props.id) {
  const resp = await axios.get("/waste-code/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  code: {
    type: "string",
    max: 12,
    required: true,
  },
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'waste-code', rules, {
  create: 'Codice Rifiuto creato con successo',
  update: 'Codice Rifiuto modificato con successo'
}, '/codici-rifiuto', () => {
  form.code = ''
})

</script>
